<div class="row">
    <div class="col-md-3" >
        <mat-button-toggle-group [(ngModel)]="preSaleView" (change)="onPresaleViewValChange(preSaleView)" aria-label="Font Style">
            <mat-button-toggle value="utilView">Utilization</mat-button-toggle>
            <mat-button-toggle value="speedingView">Speeding</mat-button-toggle>
            <mat-button-toggle value="harshEventView">Harsh Events</mat-button-toggle>
       </mat-button-toggle-group>
    </div>
    <div class="col-md-3">
        <div style="display: flex;">
            
            <label class="control-label displaying">Data Month: </label>
                                <!-- <input type="text" class="form-control" ng-model="adminInfo.Name" disabled> -->
            <!-- <h4 style="font-size: 14px;">{{ yearAndMonth || '--' }}</h4> -->
            <div><span style="font-size: 15px; padding-left: 4px;">{{ yearAndMonth || '--' }}</span></div>
        </div>

    </div>
</div>

<div class="row" [hidden] = '!(preSaleView === "utilView")' > <!-- util Presale-->
    <div class="col-md-11">
        <div class="table-responsive dashtable">
            <table id = 'utilizationPreSale' mat-table [dataSource] = "utilTblPreSaleDataSource" #sortUtilPreSale ='matSort' matSort  class="table table-condensed table-striped">
                <ng-container matColumnDef="sortBase">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        VIN/Vehicle ID
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element.vin && element.vin != 'N/A' ? (element.vin.replace(element.vin.slice(0, (element.vin.length) - 6), "") + '/') : ('/' + element.vehicleId)}}
                     </td>
                </ng-container>
                  
                <ng-container matColumnDef="vehicleType">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300">
                        Vehicle Type
                    </th>
                    <td mat-cell *matCellDef="let element" > {{element.vehicleType}} </td>
                </ng-container>
                  
                <ng-container matColumnDef="daysOperational">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Days Operational
                    </th>
                    <td mat-cell *matCellDef="let element" > {{ element.daysOperational }} ({{element.daysOperational / totalDays * 100 | number: '1.0-0'}}%) </td>
                </ng-container>

                <ng-container matColumnDef="totalMileage">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Total Mi.
                    </th>
                    <td mat-cell *matCellDef="let element" > {{element.totalMileage | number: '1.0-2'}} </td>
                </ng-container>

                <ng-container matColumnDef="sum_MovingTimeHr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Total Moving Time
                    </th>
                    <td mat-cell *matCellDef="let element" > {{element.sum_MovingTimeHr | number: '1.0-2' }} </td>
                </ng-container>

                <ng-container matColumnDef="averageOfSum_MovingTimeHr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Av. Shift
                    </th>
                    <td mat-cell *matCellDef="let element" > {{(element.daysOperational > 0 ? ( element.sum_MovingTimeHr / element.daysOperational) : 0)  | number: '1.0-2'}} </td>
                </ng-container>

                <ng-container matColumnDef="dailyMiles">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Mi./Day
                    </th>
                    <td mat-cell *matCellDef="let element" > {{element.dailyMiles | number: '1.0-2'  }} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="utilPreSaleColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: utilPreSaleColumns;" style="height:0px;"></tr>
            </table>
            <mat-paginator #paginatorUtilPreSale [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons style="margin-bottom: 4%;margin-top:-1%; background: none; color: whitesmoke;"></mat-paginator>
        </div>
    </div>

    
</div>
<div class="row" [hidden] = '!(preSaleView === "speedingView")'> <!-- util Speeding-->
    <div class="col-md-8">
        <div class="table-responsive dashtable">
            <table id = 'speedingPreSale' mat-table [dataSource] = "speedingTblPreSaleDataSource" #sortSpeedingPreSale ='matSort' matSort  class="table table-condensed table-striped">
                <ng-container matColumnDef="sortBase">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        VIN/Vehicle ID
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element.vin && element.vin != 'N/A' ? (element.vin.replace(element.vin.slice(0, (element.vin.length) - 6), "") + '/') : ('/' + element.vehicleId)}}
                     </td>
                </ng-container>
                  
                <ng-container matColumnDef="vehicleType">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300">
                        Vehicle Type
                    </th>
                    <td mat-cell *matCellDef="let element" > {{element.vehicleType}} </td>
                </ng-container>
                  
                <ng-container matColumnDef="derived_Under_5">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Under 5
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.sum_TotalMovingHr == 0 ? 0 : (element.sum_Speeding_Under_5mph_ByTime / 3600 * 100 / element.sum_TotalMovingHr) | number: '1.01-1' }}%

                    </td>
                </ng-container>
                <ng-container matColumnDef="derived_5To10">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        5 To 10
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.sum_TotalMovingHr == 0 ? 0 : (element.sum_Speeding_5_10mph_ByTime / 3600 * 100 / element.sum_TotalMovingHr) | number: '1.01-1' }}%

                    </td>
                </ng-container>

                <ng-container matColumnDef="derived_10To15">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        10 To 15
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.sum_TotalMovingHr == 0 ? 0 : (element.sum_Speeding_10_15mph_ByTime / 3600 * 100 / element.sum_TotalMovingHr) | number: '1.01-1' }}%

                    </td>
                </ng-container>

                <ng-container matColumnDef="derived_Over_15">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Over 15
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.sum_TotalMovingHr == 0 ? 0 : (element.sum_Speeding_Over_15mph_ByTime / 3600 * 100 / element.sum_TotalMovingHr) | number: '1.01-1' }}%

                    </td>
                </ng-container>

                <ng-container matColumnDef="derived_Total_Speeding">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Total Speeding
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.sum_TotalMovingHr == 0 ? 0 : (element.sum_Speeding_Under_5mph_ByTime + element.sum_Speeding_5_10mph_ByTime + element.sum_Speeding_10_15mph_ByTime + element.sum_Speeding_Over_15mph_ByTime) / 3600 *100 / element.sum_TotalMovingHr | number:'1.01-1' }}%

                    </td>
                </ng-container>

                <ng-container matColumnDef="sum_TotalMiles" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Total Mileage
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.sum_TotalMiles | number: '1.01-1' }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="speedingPreSaleColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: speedingPreSaleColumns;" style="height:0px;" ></tr>
            </table>
            <mat-paginator #paginatorSpeedingPreSale [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons style="margin-bottom: 4%;margin-top:-1%; background: none; color: whitesmoke;"></mat-paginator>
        </div>
    </div>
    
    <div class="col-md-4">  
        <div class="row text-center">
            <div class="summaryBlock">
                <h5 class="text-center" style="margin-top: -6%;margin-bottom: 2%;font-weight:bold;">Fleet Speeding Summary</h5>
                <h5 id="u5" class="inline"><u>Under 5</u> <br style="line-height: 1.5em;" /> {{ FleetData && FleetData.u5Sum /3600 * 100/ FleetData.totalMovingHrSum | number:'1.01-1' }}%</h5>
                <h5 id="_5-10" class="inline"><u>5 - 10</u> <br style="line-height: 1.5em;" /> {{ FleetData && FleetData._5T10Sum /3600 * 100 / FleetData.totalMovingHrSum | number:'1.01-1' }}%</h5>
                <h5 id="_10-15" class="inline"><u>10 - 15</u> <br style="line-height: 1.5em;" /> {{ FleetData && FleetData._10T15Sum /3600 * 100 / FleetData.totalMovingHrSum | number:'1.01-1' }}%</h5>
                <h5 id="o15" class="inline"><u>Over 15</u> <br style="line-height: 1.5em;" /> {{ FleetData && FleetData.o15Sum /3600 *100 / FleetData.totalMovingHrSum | number:'1.01-1' }}%</h5>
            </div>
        </div>                      
        

    </div>

</div>
<div class="row" [hidden] = '!(preSaleView === "harshEventView")'>
    <div class="col-md-11">
        <div class="table-responsive dashtable">
            <table id = 'harshEventPreSale' mat-table [dataSource] = "harshEventTblPreSaleDataSource" #sortHarshEventPreSale ='matSort' matSort  class="table table-condensed table-striped">
                <ng-container matColumnDef="sortBase">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        VIN/Vehicle ID
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element.vin && element.vin != 'N/A' ? (element.vin.replace(element.vin.slice(0, (element.vin.length) - 6), "") + '/') : ('/' + element.vehicleId)}}
                    </td>
                </ng-container>
                
                <ng-container matColumnDef="vehicleType">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300">
                        Vehicle Type
                    </th>
                    <td mat-cell *matCellDef="let element" > {{element.vehicleType}} </td>
                </ng-container>
                
                <ng-container matColumnDef="sum_Harsh_Brake">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Brakes
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.sum_Harsh_Brake == 0 ? "_": element.sum_Harsh_Brake }}

                    </td>
                </ng-container>
                <ng-container matColumnDef="derived_sum_Harsh_Brake_Per1k" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Brakes (per 1k)
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.sum_TotalMiles == 0 || element.sum_Harsh_Brake == 0 ? "_": ((element.sum_Harsh_Brake  * 1000 / element.sum_TotalMiles ) | number: '1.01-2')  }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="brake_Percentile" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Brakes (per 1k)
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ (companyInsProgramDr == 2 ? element.brake_Percentile_AllProgm : element.brake_Percentile) | number: '1.01-1' }} PR
                    </td>
                </ng-container>

                <ng-container matColumnDef="sum_Harsh_Corner">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Corner
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.sum_Harsh_Corner == 0 ? "_": element.sum_Harsh_Corner }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="derived_sum_Harsh_Corner_Per1k" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Corner (per 1k)
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.sum_TotalMiles == 0 || element.sum_Harsh_Corner == 0 ? "_": ((element.sum_Harsh_Corner * 1000 / element.sum_TotalMiles) | number: '1.01-1' ) }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="corner_Percentile" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Corner (per 1k)
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ (companyInsProgramDr == 2 ? element.corner_Percentile_AllProgm : element.corner_Percentile) | number: '1.01-1' }} PR
                    </td>
                </ng-container>

                <ng-container matColumnDef="sum_Harsh_Quick_Accelaration">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Accel.
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.sum_Harsh_Quick_Accelaration == 0 ? "_" : element.sum_Harsh_Quick_Accelaration }}

                    </td>
                </ng-container>
                <ng-container matColumnDef="derived_sum_Harsh_Quick_Accelaration_Per1k" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Accel. (per 1k)
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.sum_TotalMiles == 0 || element.sum_Harsh_Quick_Accelaration == 0 ? "_" : ((element.sum_Harsh_Quick_Accelaration * 1000 / element.sum_TotalMiles) | number: '1.01-2') }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="accel_Percentile" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Accel. (per 1k)
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ (companyInsProgramDr == 2 ? element.accel_Percentile_AllProgm : element.accel_Percentile) | number: '1.01-1' }} PR
                    </td>
                </ng-container>

                <ng-container matColumnDef="sum_TotalMiles" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                        Total Mi.
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.sum_TotalMiles | number: '1.01-1' }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="harshEventPreSaleColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: harshEventPreSaleColumns;" style="height:0px;" ></tr>
            </table>
            <mat-paginator #paginatorHarshEventPreSale [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons style="margin-bottom: 4%;margin-top:-1%; background: none; color: whitesmoke;"></mat-paginator>
        
        </div>
    </div>
</div>

